import {Component} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular'; // Angular Data Grid Component
import type {ColDef, GridApi, GridReadyEvent, IGetRowsParams, RowClickedEvent} from 'ag-grid-community'; // Column Definition Type Interface
import {AllCommunityModule, ModuleRegistry} from 'ag-grid-community';
import {Router} from '@angular/router';
import {InfringementListItem} from '../../intefaces/infringementListItem.interface';
import {InfringementService} from '../../services/infringement.service';
import {MatSpinner} from '@angular/material/progress-spinner';
import {StatusMessageService} from '../../services/status-message.service';

ModuleRegistry.registerModules([AllCommunityModule]);


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    AgGridAngular,
    MatSpinner
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})


export class DashboardComponent {
  isLoading = true;

  constructor(private router: Router, private infringementService: InfringementService, private statusMessage: StatusMessageService) {
  }



  //this event redirects to infringementdetail
  onRowClicked($event: RowClickedEvent<InfringementListItem, any>) {
    console.log("rowClicked")
    const infringement = $event.data;
    this.router.navigate(['/infringement-details', infringement?.identifier]);
  }

  // Data to be displayed in the grid
  rowData: InfringementListItem[] = [];


  // Column Definitions: Defines & controls grid columns.
  colDefs: ColDef<InfringementListItem>[] = [
    {field: "identifier", filter: true},
    {field: "accusedName", filter: true},
    {
      field: "accusedCountry",
      cellRenderer: (params: any) => {
        // Return plain HTML or manipulate DOM
        console.log(params.value, params.data.accusedCountryCode)
        const element = document.createElement('span');
        if (params.value && params.data.accusedCountryCode) {
          const codeLower: String = params.data.accusedCountryCode.toLowerCase()
          const flag = "https://flagcdn.com/h20/" + codeLower + ".png"
          element.innerHTML = `<img border="0" width="15" height="10" alt="${params.value} flag" src="${flag}"> ${params.value}`;
        } else {
          element.innerHTML = `No country set!`
        }
        return element;

      }, filter: true
    },
    {
      field: "dateCreated",
      cellRenderer: (data: any) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }, filter: true
    },
    {
      field: "infringementType",
      cellRenderer: (data: any) => {
        return data.value == 0 ? 'IP Infringement' : 'Contract Breach'
      }, filter: true
    },
    {field: "responsbileEmployee", filter: true}
  ];

  defaultColDef: ColDef = {
    flex: 1,
  };

  ngOnInit() {
    this.loadData()
  }

  // Method to call your service and load data based on the current page and page size.
  loadData() {
    this.isLoading = true;
    this.infringementService.getInfringementListItems()
      .subscribe(
        {
          next: (items) => {
            this.rowData = items;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Error loading data:', error);
            this.isLoading = false;
            this.statusMessage.showStatusMessage("Data could not be loaded!", "error");
          }
        }
      )
  }
}
